import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import DefRoutes from "../../../routes/routes.json";
import t from "../../../i18n/i18n";

function Header() {
  const {
    user: { admin },
  } = useSelector((store) => store.auth);

  return (
    <div className="support-header">
      <div className="header-logo-col">
        <span className="icon">
          <img src="/images/support-ico.png" alt="" />
        </span>
        <h1 className="text-uppercase">{t("Support.Title")}</h1>
      </div>
      <nav className="support-nav-warp">
        <ul>
          <li>
            <Link to={DefRoutes.Support}>
              <span className="icon">
                <img src="/images/support-ico1.png" alt="" />
              </span>
              {t("Support.Menu.Main")}
            </Link>
          </li>
          <li>
            <Link to={DefRoutes.Frequent}>
              <span className="icon">
                <img src="/images/support-ico1.png" alt="" />
              </span>
              {t("Support.Menu.Frenquently")}
            </Link>
          </li>
          <li>
            <a href={DefRoutes.Request}>
              <span className="icon">
                <img src="/images/face-icon.png" alt="" />
              </span>
              {t("Support.Menu.Request")}
            </a>
          </li>
          {admin && (
            <li>
              <Link to={DefRoutes.Admin}>
                <span className="icon">
                  <img src="/images/support-ico2.png" alt="" />
                </span>
                {t("Support.Menu.Admin")}
              </Link>
            </li>
          )}
        </ul>
      </nav>
    </div>
  );
}

export default Header;
